import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

import { ProjectsService } from 'app/modules/projects/projects.service';
import { Comment } from 'app/modules/projects/projects.types';
import { ProjectType, PropertyType, ProjectStage } from 'app/core/models/account.types';
import { AccountService } from 'app/core';
import { CurrencyMaskOptions, getCurrencyMask } from 'app/shared/Utils/common.utils';

@Component({
  selector: 'project-mark-acquired',
  templateUrl: './project-mark-acquired.component.html',
  styleUrls: ['./project-mark-acquired.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProjectMarkAcquiredComponent implements OnInit {
  projectForm: UntypedFormGroup;

  projectTypes: ProjectType[];
  propertyTypes: PropertyType[];
  projectStages: ProjectStage[];

  public uploadedFile: any;
  options: [];

  private get accountCurrency(): string {
    return this._accountService.getCurrentAccount()?.display_currency;
  }

  get currencyMaskOptions(): CurrencyMaskOptions {
    return getCurrencyMask(this.accountCurrency, 0);
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<ProjectMarkAcquiredComponent>,
    private _formBuilder: UntypedFormBuilder,
    private _projectsService: ProjectsService,
    private _accountService: AccountService,
  ) {}

  ngOnInit(): void {
    this.projectForm = this._formBuilder.group({
      id: [''],
      sale_price: ['', [Validators.required]],
      is_owner: ['true'],
      project_stage_id: [''],
      comment: [''],
    });

    this.projectStages = this.data.options.project_stages.filter((option) => !option.hidden);
    this.projectForm.patchValue(this.data.project);
  }

  onFileChanged($event) {
    let file = $event.target.files[0];
    this.uploadedFile = file;
  }

  /**
   * Discard the message
   */
  discard(): void {
    this.matDialogRef.close();
  }

  /**
   * Send the message
   */
  save(): void {
    this.projectForm.disable();

    let project = this.projectForm.value;
    project.is_owner = true;
    this._projectsService.saveProject(project).subscribe((project) => {
      let comment = <Comment>{
        body: '',
        commentable_type: null,
        commentable_id: null,
      };
      comment.body = this.projectForm.get('comment').value;
      comment.commentable_type = 'Project';
      comment.commentable_id = +project.id;
      if (comment.body) {
        this._projectsService.createComment(comment).subscribe((comment) => {
          this.matDialogRef.close();
        });
      } else {
        this.matDialogRef.close();
      }
    });
  }
}
